import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import {isAuthenticated } from "@/utils/auth"
import Layout from "../views/layout/index.vue"
import Layout1 from "../views/Layout1/index.vue"

const routes = [
  {
    path:'/login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path:'/register',
    component: () => import('@/views/login/register.vue')
  },
  {
    path:'/forgerpassword',
    component: () => import('@/views/login/forgetpassword.vue')
  },
  {
    path:'/productdetails',
    component: () => import('@/views/product/components/productdetails.vue')
  },
  {
    path: '/client',
    component:Layout1,
    children:[
      {
        path: '/management',
        component: () => import('@/views/management/index.vue')
      },
      {
        path: '/order',
        component: () => import('@/views/management/order/index.vue')
      },
      {
        path: '/orderList',
        component: () => import('@/views/management/orderList/index.vue')
      },
      {
        path: '/orderdetails',
        component: () => import('@/views/management/orderdetails/index.vue')
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children:[
      {
        path: '/index',
        component: () => import('@/views/home/index.vue')
      },
      {
        path:'/news',
        component: () => import('@/views/news/index.vue'),
      },
      {
        path:'/newsdetails',
        component: () => import('@/views/news/components/newsdetails.vue')
      },
      {
        path:'/Introduction',
        component: () => import('@/views/Introduction/index.vue')
      },
      {
        path:'/product',
        component: () => import('@/views/product/index.vue')
      },
      {
        path:'/factory',
        component: () => import('@/views/factory/index.vue')
      },
      {
        path:'/Entering',
        component: () => import('@/views/Entering/index.vue')
      },
      {
        path:'/person',
        component: () => import('@/views/person/index.vue')
      },
      {
        path:'placeOrder',
        component: () => import('@/views/management/placeOrder/index.vue')
      },
      {
        path:'listOrder',
        component: () => import('@/views/listOrder/index.vue')
      },
      {
        path:'orderDetail',
        component: () => import('@/views/orderDetail/index.vue')
      },
      {
        path:'factortDetail',
        component: () => import('@/views/factory/components/factoryDetail.vue')
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach(() => {
  window.scrollTo(0, 0); // 滚动条位置设置在最顶端的左边0，顶部0
});



// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth && !isAuthenticated()) {
//     // If the route requires authentication and the user is not authenticated
//     next('/index'); // Redirect to the login page or any other route
//   } else {
//     next(); // Continue to the next route
//   }
// });


export default router
